var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55012 11.5754C5.41679 11.5754 5.29179 11.5544 5.17512 11.5124C5.05846 11.4711 4.95012 11.4004 4.85012 11.3004L0.550123 7.00039C0.36679 6.81706 0.279123 6.57939 0.287123 6.28739C0.29579 5.99606 0.391789 5.75872 0.575122 5.57539C0.758456 5.39206 0.991789 5.30039 1.27512 5.30039C1.55846 5.30039 1.79179 5.39206 1.97512 5.57539L5.55012 9.15039L14.0251 0.675391C14.2085 0.492057 14.4461 0.400391 14.7381 0.400391C15.0295 0.400391 15.2668 0.492057 15.4501 0.675391C15.6335 0.858724 15.7251 1.09606 15.7251 1.38739C15.7251 1.67939 15.6335 1.91706 15.4501 2.10039L6.25012 11.3004C6.15012 11.4004 6.04179 11.4711 5.92512 11.5124C5.80846 11.5544 5.68346 11.5754 5.55012 11.5754Z",
    fill: "#2C74D6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default "data:image/svg+xml,%3csvg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M5.55012 11.5754C5.41679 11.5754 5.29179 11.5544 5.17512 11.5124C5.05846 11.4711 4.95012 11.4004 4.85012 11.3004L0.550123 7.00039C0.36679 6.81706 0.279123 6.57939 0.287123 6.28739C0.29579 5.99606 0.391789 5.75872 0.575122 5.57539C0.758456 5.39206 0.991789 5.30039 1.27512 5.30039C1.55846 5.30039 1.79179 5.39206 1.97512 5.57539L5.55012 9.15039L14.0251 0.675391C14.2085 0.492057 14.4461 0.400391 14.7381 0.400391C15.0295 0.400391 15.2668 0.492057 15.4501 0.675391C15.6335 0.858724 15.7251 1.09606 15.7251 1.38739C15.7251 1.67939 15.6335 1.91706 15.4501 2.10039L6.25012 11.3004C6.15012 11.4004 6.04179 11.4711 5.92512 11.5124C5.80846 11.5544 5.68346 11.5754 5.55012 11.5754Z' fill='%232C74D6'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };